import { render } from "./PromptModal.vue?vue&type=template&id=b94ec24e"
import script from "./PromptModal.vue?vue&type=script&lang=js"
export * from "./PromptModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__